import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { CommandPalette } from './components/shared/CommandPalette';
import { ThemeToggle } from './components/ui';
import { ToastContainer } from './components/ui/Toast';
import { router } from './lib/router';
import { pushNotificationService } from './services/push-notifications';
import { useApiStore } from './store/api';
import { useAuthStore } from './store/auth';

function App() {
  const { checkConnection } = useApiStore();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [showCommandPalette, setShowCommandPalette] = useState(false);

  useEffect(() => {
    // Test API connection on mount
    checkConnection();
  }, [checkConnection]);

  useEffect(() => {
    // Check auth status via cookies on mount
    // With HttpOnly cookies, we determine auth by calling /userinfo
    const checkAuth = useAuthStore.getState().checkAuth;
    checkAuth();
  }, []);

  useEffect(() => {
    // Initialize push notification service worker when authenticated
    if (isAuthenticated) {
      pushNotificationService.initialize().catch((error) => {
        console.error('[App] Failed to initialize push notifications:', error);
      });
    }
  }, [isAuthenticated]);

  // Global Cmd+K / Ctrl+K shortcut for command palette
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setShowCommandPalette((prev) => !prev);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      {/* React Router */}
      <RouterProvider router={router} />

      {/* Theme Toggle - Only show on unauthenticated pages (authenticated pages have it in their headers) */}
      {!isAuthenticated && (
        <div className="fixed bottom-4 left-4 z-50">
          <ThemeToggle />
        </div>
      )}

      {/* Global Command Palette */}
      {isAuthenticated && (
        <CommandPalette show={showCommandPalette} onClose={() => setShowCommandPalette(false)} />
      )}

      {/* Global Toast Notifications */}
      <ToastContainer />
    </>
  );
}

export default App;
